import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MyserviceService } from '../../provider/myservice.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { fee_lange } from "../../language/fee";
import * as moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { thLocale } from 'ngx-bootstrap/locale';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
defineLocale('engb', enGbLocale);
defineLocale('th', thLocale);
declare var url;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class fee {
  fee_id: string;
  customer_name: string;
  fee_date: string;
  fee_type_description: string;
  fee_price: number;
  fee_description: string;
}

@Component({
  selector: 'app-fee',
  templateUrl: './fee.component.html',
  styleUrls: ['./fee.component.scss']
})
export class FeeComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  fees: fee[];

  //fee
  search_fee = '';
  isLoading = false;
  all_fee: any;
  customer: any = {};
  filteredCustomer = [];
  submitted = false;
  actions = [
    { id: 0, action_type: { TH: "แสดงข้อมูลค่าธรรมเนียม", EN: "View fee data" } },
    { id: 1, action_type: { TH: "เพิ่มข้อมูลค่าธรรมเนียม", EN: "add fee data" } },
    { id: 2, action_type: { TH: "แก้ไขข้อมูลค่าธรรมเนียม", EN: "edit fee data" } }
  ];

  types = [
    { value: 1, name: { TH: 'รหัสค่าธรรมเนียม', EN: "Fee Id" } },
    { value: 2, name: { TH: 'วันที่ต้องชำระ (ล่าสุด)', EN: "Request Date" } },
    { value: 3, name: { TH: 'ชื่อ-นามสกุล ผู้เสียค่าธรรมเนียม', EN: "Customer " } },
    { value: 4, name: { TH: 'รายละเอียดค่าธรรมเนียม', EN: "Fee Desc" } },
    { value: 5, name: { TH: 'ชนิดค่าธรรมเนียม', EN: "Fee Type" } },
    { value: 6, name: { TH: 'ราคา', EN: "Price" } }
  ]

  type = 1;

  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;
  //drop down 
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'customer_id',
    textField: 'customer_fullname',
    selectAllText: 'เลือกทั้งหมด',
    unSelectAllText: 'ไม่เลือกทั้งหมด',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  //drop down 
  dropdownSettingsRequest: IDropdownSettings = {
    singleSelection: true,
    idField: 'request_general_id',
    textField: 'request_general_id',
    selectAllText: 'เลือกทั้งหมด',
    unSelectAllText: 'ไม่เลือกทั้งหมด',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  dataTable: any = "";
  action = this.actions[0];
  fee_types: any;
  customer_places: any;
  customers: any;
  gen_types: any = [];
  gen_type_times: any = [];
  // bsInlineValue=new Date();
  fee = { fee_id: "", fee_description: "", fee_date: moment().format("YYYY-MM-DD"), fee_type_id: "", fee_price: "", customer_id: "", fee_count: "", place_id: "", gen_type_id: "", gen_type_time: "", request_general_id: "", request_desc: "", service_price: "" };
  request_general: [];
  bsValue: Date;
  httpOptions: any;
  token = '';
  database = '';

  constructor(
    private http: HttpClient,
    private service: MyserviceService,
    private chRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private localeService: BsLocaleService,
    private router: Router,
    private modalService: BsModalService) {
    this.language = fee_lange[this.lang];
  }

  isFloat = value => !/^\s*$/.test(value) && !isNaN(value)

  ngOnInit(): void {

    if (sessionStorage.getItem('municipality') != undefined) {
      this.database = JSON.parse(sessionStorage.getItem('municipality')).municipality_id + '_fee'
    }

    if (sessionStorage.getItem('token') != undefined) {
      this.token = sessionStorage.getItem('token');
    }

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        'x-access-token': this.token,
        'database': this.database
      })
    };
    console.log(url + 'fee/get_to_datatable');
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      language: {
        emptyTable: 'NO Records',
        zeroRecords: '',
      },
      ajax: (dataTablesParameters: any, callback) => {
        that.http
          .post<DataTablesResponse>(
            url + 'fee/get_to_datatable',
            dataTablesParameters, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8',
              'x-access-token': this.token,
              'database': this.database
            })
          }
          ).subscribe(resp => {
            console.log(resp);
            that.fees = resp.data.map((item) => {
              var xy = 0;
              xy = parseInt(moment(item.fee_date).format('YYYY'));

              if (xy < 2500) {
                xy = xy + 543;
              }

              item.show_date = moment(item.fee_date).format('DD/MM/') + xy;
              item.fee_date = moment(item.fee_date).format('YYYY-MM-DD');
              return item;
            });
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [{ data: 'fm.fee_id' }, { data: 'c.customer_name' }, { data: 'fm.fee_description' }, { data: 'to_char(fm.fee_date,\'YYYY-MM-DD\')' }, { data: 'c.customer_surname' }, { data: 'ft.fee_type_description' }, { data: '(fm.fee_price :: VARCHAR)' }, { data: '' }]
    };

    this.service.postData({}, "get_gen_type").then((result: any) => {
      if (result.code) {
        Swal.fire(result.message, '', 'error')
      } else {
        this.gen_types = result.data;
      }
    })
    this.service.postData({}, "customer/get").then((result: any) => {
      if (result.hasError) {
        Swal.fire(result.message, '', 'error');
      } else {
        this.customers = result.data;
        this.filteredCustomer = [];
        if (this.customers.length > 20) {
          for (var i = 0; i <= 20 - 1; i++) {
            this.filteredCustomer.push(this.customers[i]);
          }
        }
        else {
          for (var i = 0; i <= this.customers.length - 1; i++) {
            this.filteredCustomer.push(this.customers[i]);
          }
        }
      }
    })

    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (params['lang'] != 'EN' && params['lang'] != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';
        this.language = fee_lange[this.lang];
        this.localeService.use(this.lang.toLowerCase());
      } else {
        this.localeService.use(params['lang'].toLowerCase());
        this.language = fee_lange[params['lang']];
        localStorage.setItem('lang', params['lang']);
      }
    });
  }

  edit(fee) {
    this.fee = fee;
    this.refresh_gen_type();
    this.action = this.actions[2];
    this.isLoading = true;
    this.getCustomer_place();
    this.service.postData({}, "fee-type/get").then((result: any) => {
      this.fee_types = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))
      this.change_fee_count();
      this.service.postData({ customer_id: fee.customer_id }, "request-general/get").then((result2: any) => {
        this.isLoading = false;
        this.request_general = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""))

        this.customer = [
          {
            customer_id: fee.customer_id,
            customer_fullname: fee.customer_name
          }]
      })
    })
  }

  getCustomer_place() {
    this.service.postData({ customer_id: this.fee.customer_id }, "customer-place/get").then((result: any) => {
      this.customer_places = result.data;
    }, err => {
      window.location.href = this.service.start_host
    })
  }

  change_fee_count() {
    if (this.isFloat(this.fee.fee_count)) {
      var fee_type = this.fee_types.filter((item) => item.fee_type_id == this.fee.fee_type_id);

      if (fee_type.length > 0) {
        this.fee.fee_price = "" + parseInt(this.fee.fee_count) * parseInt(fee_type[0].fee_type_price);
      }
      else {
        this.fee.fee_price = "";
      }
    }
    else {
      this.fee.fee_price = "";
    }

  }

  change_gen_type() {
    this.fee.gen_type_time = "";
    this.refresh_gen_type();
  }

  add() {
    // debugger
    this.isLoading = true;
    this.action = this.actions[1];
    this.service.postData({}, "fee/getId").then((result: any) => {
      this.fee.fee_id = result.max_id;
    });

    this.service.postData({}, "fee-type/get").then((result: any) => {
      this.fee_types = result.data;
      this.change_fee_count();
      this.isLoading = false;
      this.customer = [];
    })


    this.service.postData({}, "customer/get").then((result: any) => {
      if (result.hasError) {
        Swal.fire(result.message, '', 'error');
      } else {
        this.customers = result.data;
        this.filteredCustomer = [];
        if (this.customers.length > 20) {
          for (var i = 0; i <= 20 - 1; i++) {
            this.filteredCustomer.push(this.customers[i]);
          }
        }
        else {
          for (var i = 0; i <= this.customers.length - 1; i++) {
            this.filteredCustomer.push(this.customers[i]);
          }
        }
      }
    })
  }

  refresh_gen_type() {
    //console.log(this.fee.gen_type_time)
    this.gen_type_times = [];
    switch (this.fee.gen_type_id) {
      case '01':
        for (var i = 1; i <= 24; i++) {
          this.gen_type_times.push({ gen_type_time_id: i % 24, gen_type_time_name: i < 10 ? '0' + i + ':00:00' : i + ':00:00' })
        }
        break;
      case '02':
        var date = [
          { value: 0, name: { TH: 'วันอาทิตย์', EN: "Sunday" } },
          { value: 1, name: { TH: 'วันจันทร์', EN: "Monday" } },
          { value: 2, name: { TH: 'วันอังคาร', EN: "Tuesday" } },
          { value: 3, name: { TH: 'วันพุธ', EN: "Wednesday" } },
          { value: 4, name: { TH: 'วันพฤหัสบดี', EN: "Thursday" } },
          { value: 5, name: { TH: 'วันศุกร์', EN: "Friday" } },
          { value: 6, name: { TH: 'วันเสาร์', EN: "Saturday" } },
        ];
        this.gen_type_times = date.map((item) => {
          return {
            gen_type_time_id: item.value,
            gen_type_time_name: item.name[this.lang]
          }
        })
        break;
      case '03':
        for (var i = 1; i <= 31; i++) {
          this.gen_type_times.push({ gen_type_time_id: i, gen_type_time_name: i < 10 ? '0' + i : i })
        }
        break;
      case '04':
        var months = [
          // {value:0,name_th:'all',n},
          { value: 1, name: { TH: 'มกราคม', EN: "January" } },
          { value: 2, name: { TH: 'กุมภาพันธ์', EN: "February" } },
          { value: 3, name: { TH: 'มินาคม', EN: "March" } },
          { value: 4, name: { TH: 'เมษายน', EN: "April" } },
          { value: 5, name: { TH: "พฤษภาคม", EN: "May" } },
          { value: 6, name: { TH: "มิถุนายน", EN: "June" } },
          { value: 7, name: { TH: "กรกฏาคม", EN: "July" } },
          { value: 8, name: { TH: "สิงหาคม", EN: "August" } },
          { value: 9, name: { TH: "กันยายน", EN: "September" } },
          { value: 10, name: { TH: "ตุลาคม", EN: "October" } },
          { value: 11, name: { TH: "พฤศจิกายน", EN: "November" } },
          { value: 12, name: { TH: "ธันวาคม", EN: "December" } }
        ];
        this.gen_type_times = months.map((item) => {
          return {
            gen_type_time_id: item.value,
            gen_type_time_name: item.name[this.lang]
          }
        })

    }
  }

  back() {
    this.action = this.actions[0];
    this.submitted = false;
    this.fee = { fee_id: "", fee_description: "", fee_date: moment().format("YYYY-MM-DD"), fee_type_id: "", fee_price: "", customer_id: "", fee_count: "", place_id: "", gen_type_id: "", gen_type_time: "", request_general_id: "", request_desc: "", service_price: "" }
  }

  private _filterCustomer(subject_text: string): any[] {
    const filterValue = subject_text.toLowerCase();

    return this.customers.filter(option => (option.customer_name + ' ' + option.customer_surname).toLowerCase().indexOf(filterValue) === 0);
  }

  onItemSelect(item: any) {
    console.log(this.customer);
    this.fee.customer_id = this.customer[0].customer_id;
    this.getCustomer_place();

    this.service.postData({ customer_id: this.fee.customer_id }, "request-general/get").then((result2: any) => {
      this.isLoading = false;
      this.request_general = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""))
    })
  }
  onSelectAll(items: any) {
    console.log(this.customer);
    this.customer = [];
    this.customer = items;
  }

  onItemDeSelect(deitem: any) {
    console.log(this.customer);
  }
  onDeSelectAll(items: any) {
    this.customer = [];
    console.log(this.customer);
    this.fee.customer_id = '';
  }

  onFilterCustomer(item: any) {
    console.log(item);
    if (item.length >= 2) {
      this.filteredCustomer = [];
      var filteredCustomer = this._filterCustomer(item)

      if (filteredCustomer.length > 0) {
        if (filteredCustomer.length > 20) {
          for (var i = 0; i <= 20 - 1; i++) {
            this.filteredCustomer.push(filteredCustomer[i]);
          }
        }
        else {
          for (var i = 0; i <= filteredCustomer.length - 1; i++) {
            this.filteredCustomer.push(filteredCustomer[i]);
          }
        }

      }
      else {
        if (this.customers.length > 20) {
          for (var i = 0; i <= 20 - 1; i++) {
            this.filteredCustomer.push(this.customers[i]);
          }
        }
        else {
          for (var i = 0; i <= this.customers.length - 1; i++) {
            this.filteredCustomer.push(this.customers[i]);
          }
        }
      }
    }
  }

  save() {
    var url;
    this.service.postData({}, "fee/getId").then((result: any) => {
      if (!result.code) {
        debugger
        this.submitted = true;
        //console.log(this.fee);
        var d = new Date(this.fee.fee_date);
        // console.log(moment(this.fee.fee_date).format('YYYY-MM-DD'));
        this.fee.fee_date = `${moment(this.fee.fee_date).format('YYYY-MM-DD')}`
        if (this.action.id == 1) {
          url = "fee/create";
        } else if (this.action.id == 2) {
          url = "fee/update";
        }

        if (!this.fee.place_id || !this.fee.fee_id || !this.fee.fee_description || !this.fee.fee_date || !this.fee.fee_price  || !this.fee.fee_type_id || !this.fee.fee_price || !this.fee.customer_id || !this.fee.fee_count
          || !this.fee.gen_type_id || !this.fee.request_general_id|| !this.fee.service_price ) {
          Swal.fire({
            title: 'ข้อมูลไม่ครบถ้วน',
            text: '',
            type: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2000
          })
          return this.isLoading = false;
        }
        
        this.isLoading = true;
        this.service.postData(this.fee, url).then(result => {
          this.isLoading = false;
          Swal.fire({
            title: this.language.saved,
            text: '',
            type: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2000
          }).then(result => {
            this.back();
          })
        }, (err) => {
          this.isLoading = false;
          Swal.fire({
            title: this.language.no_internet_alert,
            text: '',
            type: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2000
          });
        });
      }
    }, (err) => {
      this.isLoading = false;
      Swal.fire(
        {
          title: this.language.no_internet_alert,
          text: '',
          type: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        });
    });
  }

  isDate(date) {

    if (date == '') {
      return true;
    } else {
      var d = new Date(date);
      return !isNaN(d.getTime())
    }
  }


  delete() {
    Swal.fire({
      title: this.language.confirm_delete,
      text: this.language.warning_delete,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.language.want_delete,
      cancelButtonText: this.language.close
    }).then((result) => {
      if (result.value) {
        this.isLoading = true;
        this.service.postData({ fee_id: this.fee.fee_id }, "fee/delete").then((result) => {
          this.isLoading = false;
          Swal.fire({
            title: this.language.deleted,
            text: '',
            type: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2000
          }).then((result) => {
            this.action = this.actions[0];
          })
        }, (err) => {
          this.isLoading = false;
          Swal.fire({
            title: this.language.no_internet_alert,
            text: '',
            type: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2000
          })
        })
      }
    });

  }

}